<template>
  <div>
    <top-header></top-header>
    <main-menu></main-menu>
    <!-- Start the code for this screen here -->
    <div class="pagecontainer">
      <div class="container">
        <div class="heading"><span><b>View Activity</b></span></div>
        <br>
        <div class="form-group">
          <label name="Dealer Name">Dealer Name</label>
          <select v-model.trim="searchCriteria.dealerId" style="width: 10.6%;">
            <option disabled value=""> Select Dealer </option>
            <option v-for="dealer in dealerNames" v-bind:value="dealer.dealerId" v-bind:key="dealer.dealerId"> {{
              dealer.dealerName }} </option>
          </select>
          <label name="Sales Agent">Salesperson</label>
          <select v-if="this.disablesalesrepdd" v-model.trim="searchCriteria.salesAgentId" style="width: 10.6%;" disabled>
            <option selected v-for="sa in salesAgents" v-bind:value="sa.employeeId" v-bind:key="sa.employeeId"> {{
              sa.firstName }} , {{ sa.lastName }} </option>
          </select>
          <select v-else v-model.trim="searchCriteria.salesAgentId" style="width: 10.6%;"> <!-- Admin and BO-->
            <option disabled value=""> Selectperson </option>
            <option v-for="sa in salesAgents" v-bind:value="sa.employeeId" v-bind:key="sa.employeeId"> {{ sa.firstName }}
              , {{ sa.lastName }} </option>
          </select>
          <label id="aType" name="Activity Type">Activity Type</label>
          <select v-model.trim="searchCriteria.activityType" style="width: 10.6%;">
            <option disabled value=""> Select activity Type </option>
            <option v-for="activityT in activtyTypes" v-bind:value="activityT.key" v-bind:key="activityT.key"> {{
              activityT.value }} </option>
          </select>
          <button type="submit" @click="searchActivities">Search</button>
          <button type="submit" @click="resetsearch">Reset</button>
        </div>
        <!--  <div class="form-group">
        <label  name="Month" >Month</label>
        <select v-model.trim="searchCriteria.month" style="width: 10.6%;">
        <option disabled value=""> Select Month </option>
        <option v-for="month in months" v-bind:value="month.month" v-bind:key="month.month"> {{ month.month}} </option>
      </select>
      <label name="Date Rangef"> Date Range </label>
      <input type="Date"  v-model.trim="searchCriteria.fromDate" style="width: 10.6%;"/>
      <label name="Date RangeT"> To </label>
      <input type="Date"  v-model.trim="searchCriteria.toDate" style="width: 10.6%;"/>
      <button type="submit" @click="searchActivities">Search</button>
      <button type="submit" @click="resetsearch">Reset</button>
      </div> -->
        <br>
        <!-- horizontal line break -->
        <div class="horizontal-line"></div>
        <br>
        <!-- Table Data start-->
        <table id="activitytable" class="table-month-table">
          <tr class="table-month-row">
            <th v-for="(col, index) in colheaders" :key="index" class="table-month-header-blue"><span>{{ col.header }}</span>
            </th>
          </tr>
          <tr v-for="(activity, dindex) in activitiesForDisplay" :key="dindex" class="table-month-row">
            <td class="table-month-td">
              {{ activity.firstName }} , {{ activity.lastName }}
            </td>
            <td class="table-month-td">
              {{ activity.activityDate }}
            </td>
            <td class="table-month-td">
              {{ activity.activityType }}
            </td>
            <td class="table-month-td">
              {{ activity.activitySourceType }}
            </td>
            <td class="table-month-td">
              {{ activity.dealerName }}
            </td>
            <td class="table-month-td">
              {{ activity.visitPurposeType }}
            </td>
            <td class="table-month-td">
              {{ activity.visitQuality }}
            </td>
            <td class="table-month-td">
              {{ activity.activityNotes }}
            </td>
          </tr>
        </table>
        <!-- <template v-if="this.norecordsfound">
            <p align ="center" class="alert-danger"> No Records found!!! Refine your search</p>
      </template>  -->
        <br>
        <div style="width:5%; text-align:center; ">
          <download-excel class="export-button" name="Activity.xls" title="Activities Extract" worksheet="Activity"
            :fetch="exportActivities" :fields="activity_fields_export" type="xls">
            Export Activity
          </download-excel>
          <!-- <button type="submit" @click="exportActivities">Export Activity</button> -->
        </div>
        <!-- End of the code for this screen here -->
      </div>
    </div> <!-- page container end-->
    <bottom-footer></bottom-footer>
  </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import commonservice from '../js/http-common'
import activityTraking from '../js/http-activitytracking'
import manageSourceSvc from '../js/http-managesource'
import manageemployeeSvc from '../js/http-employee.js'

export default {
  components: {
    MainMenu,
    TopHeader,
    BottomFooter
  },
  name: 'viewActivity',
  data() {
    return {
      currentYear: new Date().getFullYear,
      norecordsfound: false,
      dealerNames: [], // gets data from service
      salesAgents: [], // get employee data that are salesperson
      disablesalesrepdd: false,
      activtyTypes: [
        { key: 'Visit', value: 'Visit' },
        { key: 'Phone Contact', value: 'Phone Contact' },
        { key: 'Email Contact', value: 'Email Contact' }
      ],
      activitiesForDisplay: [],
      months: [
        { month: 'Jan', key: '01/01/' + this.currentYear },
        { month: 'Feb' },
        { month: 'Mar' },
        { month: 'Apr' },
        { month: 'May' },
        { month: 'Jun' },
        { month: 'Jul' },
        { month: 'Aug' },
        { month: 'Sep' },
        { month: 'Oct' },
        { month: 'Nov' },
        { month: 'Dec' }
      ],
      colheaders: [
        { header: 'Rep Name' },
        { header: 'Activity Date' },
        { header: 'Activity Type' },
        { header: 'Activity Source' },
        { header: 'Dealer Name' },
        { header: 'Visit Purpose' },
        { header: 'Visit Quality' },
        { header: 'Notes' }
      ],
      searchCriteria: {
        dealerId: '',
        activityType: '',
        salesAgentId: this.$session.get('user_role') == 'SR' ? this.$session.get('employee_id') : '',
        month: '',
        fromDate: '',
        toDate: ''
      },
      activity_fields_export: {
        'Activity Date': 'activityDate',
        'Salesperson Name': 'firstName',
        'Activity Type': 'activityType',
        'Activity Source': 'activitySourceType',
        'Dealer Name': 'dealerName',
        'Visit Purpose': 'visitPurposeType',
        'Visit Quality': 'visitQuality',
        'Notes': 'activityNotes'
      }
    }
  },
  methods: {
    searchActivities: function () {
      console.log('Search Criteria: ' + JSON.stringify(this.searchCriteria))
      activityTraking.get('/search', {
        params: {
          dealerId: this.searchCriteria.dealerId,
          actType: this.searchCriteria.activityType,
          agentId: this.searchCriteria.salesAgentId,
          // month : this.searchCriteria.month, TODO- When month selected, Set the TO and From Dates
          fromDate: this.searchCriteria.fromDate,
          toDate: this.searchCriteria.toDate
        }
      }).then(response => {
        console.log('Search Results:' + JSON.stringify(response.data))
        this.activitiesForDisplay = response.data
        if (this.activitiesForDisplay.length != 0) {
          this.norecordsfound = false
        } else {
          this.norecordsfound = true
        }
      }).catch(e => {
        console.log('Error during search API call')
        this.norecordsfound = true // TODO - Display proper error message?
        this.activitiesForDisplay = []
      })
    },
    resetsearch() {
      console.log('Resetting the search and results'),
        this.searchCriteria = this.createeEmptySearchObject(),
        this.activitiesForDisplay = [],
        this.norecordsfound = false
    },
    createeEmptySearchObject() {
      return {
        dealerId: '',
        activityType: '',
        salesAgentId: this.$session.get('user_role') == 'SR' ? this.$session.get('employee_id') : '',
        month: '',
        fromDate: '',
        toDate: ''
      }
    },
    retrieveActivities() {
      this.createeEmptySearchObject()
      this.searchActivities()
    },
    getAssignedDealers(repId) {
      manageemployeeSvc.get('/employee/salesrepdealers/' + repId).then(Response => {
        if (Response.data.length != 0) {
          this.dealerNames = Response.data
        }
      })
        .catch(error => {
          console.log('Failed to load dealer list dropdown:' + error)
        })
    },
    getAllDealers() {
      manageSourceSvc.get('/dealersearch').then(Response => {
        if (Response.data.length != 0) {
          this.dealerNames = Response.data
        }
      })
        .catch(error => {
          console.log('Failed to load dealer list dropdown:' + error)
        })
    },
    fetchData() {
      // get Dealers dropdown
      // Logged in user Sales REP?
      if (this.$session.get('user_role') == 'SR') {
        this.getAssignedDealers(this.$session.get('employee_id'))
      } else {
        this.getAllDealers()
      }
      // get Sales reps
      // Check if the logged in used is sales rep
      console.log('User Role:' + this.$session.get('user_role'))
      if (this.$session.get('user_role') == 'SR') {
        this.salesAgents = [
          {
            'employeeId': this.$session.get('employee_id'),
            'firstName': this.$session.get('first_name'),
            'lastName': this.$session.get('last_name')
          }
        ]
        this.searchCriteria.salesAgentId = this.$session.get('employee_id')
        // disable the Dropdown
        this.disablesalesrepdd = true
      } else {
        this.disablesalesrepdd = false
        // create objet
        let searchEmployee = {
          'firstName': '',
          'lastName': '',
          'roleType': 'SR', // Sales Reps Only
          'statusCode': ''
        }
        manageemployeeSvc.post('/employee/search/', searchEmployee).then(response => {
          this.salesAgents = response.data
        })
          .catch(e => {
            console.log('Failed to load salesperson:' + e)
          })
      }
      // get activities - By defeault pull last 10 or 30 days?
      this.retrieveActivities()
    },
    async exportActivities() {
      const response = await activityTraking.get('/search') // Just pull all records
      // console.log("Export Response: "+response);
      // console.log("Activities to Export: "+ JSON.stringify(response.data));
      return response.data
    }
  },
  mounted() {
    this.fetchData()
  }
}
</script>
<style scoped></style>
